export default {
    token: null,
    user: null,
    accessProfile: null
};
